<template>
    <div
        class="select-none overflow-visible"
        :class="{
            relative: relative,
        }"
        v-click-outside="hideOut"
    >
        <button type="button" class="cursor-pointer w-full outline-0" @click="toggle" :tabindex="tabindex">
            <slot name="button" :open="open" />
        </button>

        <!--  transition-max-h duration-500 ease-in -->

        <TransitionHeight
            ref="menu"
            class="z-40"
            :visable="open"
            v-if="!button"
            :style="[menuStyle, hasShadow ? 'box-shadow: 0px 10px 20px 0px rgb(0 0 0 / 20%);' : '']"
            :class="[
                menuClass,
                {
                    'right-0': position == 'right',
                    'right-0 top-0': position == 'bottom-right',
                    'w-full right-0 left-0': position == 'full',
                    'absolute w-auto': !block,
                    'lg:absolute w-full': block,
                    'relative w-full': position == 'relative',
                },
            ]"
        >
            <!-- <TransitionHeight :visable='open'> -->
            <div @click="detectClose">
                <slot name="menu" :open="open" />
            </div>
            <!-- </TransitionHeight> -->
            <!-- <div class='h-0 select-none'
				:class='{
					"h-auto": open,
				}'
				@click='detectClose'
			>
				<slot name='menu' />
			</div> -->
        </TransitionHeight>

        <slot name="blackout" :open="open" v-if="blackout" />
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
    name: 'Dropdown',

    props: {
        button: {
            type: Boolean,
            default: false,
        },
        position: {
            type: String,
            default: null,
        },
        menuClass: {
            type: String,
            default: null,
        },
        menuStyle: {
            type: Object,
            default: null,
        },
        // blackout: {
        // 	type: Boolean,
        // 	default: false
        // },
        enabled: {
            type: Boolean,
            default: true,
        },
        block: {
            type: Boolean,
            default: false,
        },
        relative: {
            type: Boolean,
            default: true,
        },
        transition: {
            type: Boolean,
            default: true,
        },
        allowClickOutSide: {
            type: Boolean,
            default: true,
        },
        loadOpen: {
            type: Boolean,
            default: false,
        },
        tabindex: {
            default: null,
        },
        hasShadow: { default: false, type: Boolean },
    },

    mounted() {
        if (this.transition) {
            // this.$smoothElement({
            //     el: this.$refs.menu,
            //     transition: 'height .3s'
            // })
        }

        if (this.loadOpen) {
            this.show()
        }
    },

    data() {
        return {
            open: false,
            blackout: false,
        }
    },

    methods: {
        toggle() {
            if (!this.enabled) {
                return
            }

            if (this.open) {
                this.hide()
            } else {
                this.show()
            }
        },

        show() {
            if (this.open) {
                return
            }

            this.open = true
            this.blackout = true

            if (!this.loadOpen) {
                this.$emit('dropdown', this.open)
            }
        },

        hide() {
            if (this.open) {
                this.open = false
                this.$emit('dropdown', this.open)

                setTimeout(() => {
                    this.blackout = false
                    this.$emit('hide')
                }, 300)
            }
        },

        focus(event) {
            // console.log(event);

            // if (event.relatedTarget == null || String(event.relatedTarget).indexOf('input.') !== -1) {
            // 	return;
            // }

            setTimeout(() => {
                if (!this.open) {
                    this.show()
                }
            }, 30)
        },

        hideOut() {
            if (!this.allowClickOutSide || !this.open) {
                return
            }

            this.$nextTick(() => {
                this.hide()
            })
        },

        detectClose(e) {
            if (this.$help.getParentUntil(this.$el, e.target) === false) {
                return
            }

            if (e.target.dataset.close !== undefined || e.target.parentElement.dataset.close !== undefined) {
                this.hide()
            }
        },
    },

    directives: {
        ClickOutside,
    },
}
</script>
